import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@zillow/constellation-10';

import type { EnteredValue, SectionCategory } from '../../models/Summary';
import FieldRow from './FieldRow';
import SummarySection from './SummarySection';

type Props = {
  descriptionOverride?: ReactNode;
  showEditLink: boolean;
  sectionCategory: SectionCategory;
  getLeasingStatusForNode(nodeId: number): void;
};

export default function SectionCategoryRepresentation({
  showEditLink,
  sectionCategory,
  descriptionOverride,
  getLeasingStatusForNode,
}: Props) {
  const { displayName, description, enteredValues } = sectionCategory;

  return (
    <SummarySection
      headerText={displayName}
      description={descriptionOverride || description}
      isComplete={sectionCategory.isComplete()}
    >
      {enteredValues.map((enteredValue: EnteredValue, index) => (
        <React.Fragment key={index}>
          <FieldRow
            showEditLink={showEditLink}
            enteredValue={enteredValue}
            getLeasingStatusForNode={getLeasingStatusForNode}
            sectionCategory={sectionCategory.sectionCategory}
          />
          {index < enteredValues.length - 1 && <Box css={{ marginBottom: 'tight' }} />}
        </React.Fragment>
      ))}
    </SummarySection>
  );
}
